
import { useEffect, useState } from "react"

import { get_performant_state_reference } from "../../../state_performant_accessor"
import { H3R4_CELL_TO_XY } from "../../data/eez/data"
import pub_sub from "../../state/pub_sub"
import { LightningBoltFlow } from "./LightningBoltFlow"


interface FlowEntry
{
    id: string
    x: number
    y: number
    generated_GW: number
    // demand_GW: number
}

export function MapLightningBoltFlow()
{
    const [flows, set_flows] = useState<FlowEntry[]>([])

    useEffect(() => pub_sub.sub("simulation_datetime_step", () =>
    {
        const performant_accessor = get_performant_state_reference()

        const next: FlowEntry[] = Object.keys(performant_accessor.sim_state_by_h3r4).map(h3r4_id =>
        {
            const generated_GW = (
                (performant_accessor.sim_state_by_h3r4[h3r4_id]?.power_plants?.total_generated_MW.total_positive ?? 0)
                // + (gen_cap_store_MW_by_h3r4[h3r4_id]?.total_generated_MW.storage ?? 0)
            ) / 1000
            // const demand_GW = demand_GW_by_h3r4[h3r4_id]?.demand_GW ?? 0
            // if (!generated_GW && !demand_GW) return
            if (!generated_GW) return
            const xy = H3R4_CELL_TO_XY.get(h3r4_id)
            if (!xy) return

            const entry: FlowEntry = { id: h3r4_id, x: xy.x, y: xy.y, generated_GW }
            return entry
        }).filter(f => f !== undefined) as FlowEntry[]

        set_flows(next)
    }, "MapLightningBoltFlow"), [])

    return <group>
        {flows.map(f => (
            <LightningBoltFlow
                key={f.id}
                x={f.x}
                y={f.y}
                generated_GW={f.generated_GW}
                // Do not show demand, instead we'll reserve the red lighting bolts
                // for power shortage
                // demand_GW={f.demand_GW}
                demand_GW={0}
            />
        ))}
    </group>
}
